import {
  Car, Crosshair, Laptop, Tablet, Camera, Monitor, Package, ShoppingBag, Microscope, Antenna, Wrench, ShieldAlert, Radar, Fingerprint, Globe,
} from "lucide-react";

export const CAT_ICONS = {
  kendaraan: Car,
  senpi: Crosshair,
  laptop: Laptop,
  ipad_hp: Tablet,
  drone_kamera: Camera,
  pc: Monitor,
  cobweb: Package,
  cybershop: ShoppingBag,
  almatsus_lab: Microscope,
  almatsus_df: Antenna,
  almatsus_harwat: Wrench,
  almatsus_patroli: ShieldAlert,
  polda_forensik: Fingerprint,
  polda_df: Radar,
  polda_patroli: Globe,
};

export const POLDA_CATS = ["polda_forensik", "polda_df", "polda_patroli"];
export const POLDA_CAT_SHORT = { polda_forensik: "Forensik", polda_df: "DF", polda_patroli: "Patroli" };

export const GROUP_LABEL = {
  Sarpras: "Sarana & Prasarana",
  Almatsus: "Almatsus Dittipidsiber",
  Polda: "Ditressiber Polda",
};
